// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3OY_Q","visible":"Menu_visible__2GFEE","hidden":"Menu_hidden__23OJA","menuDivider":"Menu_menuDivider__3GfDp","menuButton":"Menu_menuButton__2EHPQ"};